import type { ReactNode } from "react";
import { colors, fontSize, fontWeight, space } from "../lib/tokens";
import { useViewport } from "../hooks/useViewport";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  const vp = useViewport();
  const isMobile = vp === "mobile";
  return (
    <div style={{
      marginBottom: isMobile ? space.xxl : space.xxxl,
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "stretch" : "flex-start",
      justifyContent: "space-between",
      gap: isMobile ? space.md : space.xxl,
    }}>
      <div>
        <h1 style={{
          fontSize: isMobile ? "22px" : fontSize.h1,
          fontWeight: fontWeight.medium,
          letterSpacing: "-0.018em",
          lineHeight: 1.15,
          marginBottom: 6,
        }}>
          {title}
        </h1>
        {subtitle && <p style={{ color: colors.stone, fontSize: fontSize.base }}>{subtitle}</p>}
      </div>
      {actions && <div style={{ display: "flex", gap: space.sm, alignItems: "center", flexWrap: "wrap" }}>{actions}</div>}
    </div>
  );
}
